<template>
  <v-container fluid>
    <v-flex xs12>
      <FaqList />
    </v-flex>
  </v-container>
</template>

<script>
import FaqList from '../components/Faq/FaqList.vue';

export default {
  name: 'faq',
  components: {
    FaqList,
  },
};
</script>
